import { render, staticRenderFns } from "./plan_detail.vue?vue&type=template&id=052f037a&scoped=true"
import script from "./plan_detail.vue?vue&type=script&lang=js"
export * from "./plan_detail.vue?vue&type=script&lang=js"
import style0 from "./plan_detail.vue?vue&type=style&index=0&id=052f037a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f037a",
  null
  
)

export default component.exports